import {
  LabeledFilter,
  getFilterStore,
} from "../../../components/dataGridFilter/createFilterStore";

export const getOrderFilterStore = (filterField: string) => {
  const isAll = filterField === "all";
  const key = isAll ? "orders" : `orders-${filterField}`;
  const initialFilters: Record<string, LabeledFilter> = isAll
    ? {}
    : {
        [filterField]: {
          field: filterField,
          operator: "eq",
          value: true,
        },
      };

  return getFilterStore(initialFilters, "orders", key);
};
